import { CommandAction } from "src/app/abstract/command/command-action.service";
import { WidgetsSectionModel } from "src/app/models/widgets/widgets-section.model";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";
import { Injectable } from "@angular/core";
import { WidgetsTypeEnum } from "src/app/enums/widgets/widgets-type.enum";
import { WidgetsService } from "../widgets/widgets.service";
import { Logger } from "src/app/core/logger";
import { WidgetsComponentAbstract } from "src/app/abstract/widgets/widgets-component.abstracts";
import { WidgetsContainerAbstract } from "src/app/abstract/widgets/widgets-container.abstract";
import { WidgetsFormModel } from "src/app/models/widgets/widgets-form.model";
import PrettySequenceHelper from "src/app/shared/form-builder-util/pretty-sequence";
import { WidgetsMetadataService } from "../widgets/widgets-metadata.service";
import { WidgetsSelectionService } from "../widgets/widgets-selection.service";

@Injectable()
export class CommandSectionService extends CommandAction {

    constructor(private logger: Logger,
        private widgetsService: WidgetsService,
        private selectionService: WidgetsSelectionService) {
        super();
    }

    public execute(parent:WidgetsAbstract, widget: WidgetsAbstract): WidgetsSectionModel {
        const newSection = new WidgetsSectionModel();
        newSection.parentId =  parent.id;

        if (parent instanceof WidgetsSectionModel) {
            // "Subsection": Child of another section
            const parentSection = parent as WidgetsSectionModel;
            newSection.level = parentSection.level + 1;

            // Assign latest section sequence of same level
            newSection.seq = Object.assign([], parentSection.seq);
            const nextSeq : number = this.widgetsService.getNextSection(parentSection);
            newSection.seq.push(nextSeq);
        } else if (parent instanceof WidgetsFormModel) {
            // Top level section. Child of Form
            // Assign latest section sequence on top level
            const parentForm = parent as WidgetsFormModel;
            const nextSeq = this.widgetsService.getNextSection(parentForm);
            newSection.seq = [ nextSeq ];
        }

        newSection.label = newSection.label + ' ' + PrettySequenceHelper.formatSequence(newSection.seq);
        newSection.name = newSection.label;

        // A new Section borns selected
        this.selectionService.select(newSection).then(() => {
            this.widgetsService.setLayoutTouched(); 
        });
        return newSection;        
    }
}
